import * as reactQuery from '@tanstack/react-query';

import { IncidentClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const incidentClient = new IncidentClient(apiBaseUrl);

function useGetIncidents(ids: number[], hours: number) {
  return reactQuery.useQuery({
    queryKey: [queryKeys.Incident.GetMany, ids],
    queryFn: () => incidentClient.getIncidents(ids, hours),
  });
}

export default useGetIncidents;
